import { render, staticRenderFns } from "./DataCotizaciones.vue?vue&type=template&id=e6fa1be4&"
import script from "./DataCotizaciones.vue?vue&type=script&lang=js&"
export * from "./DataCotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports